export default "__VITE_ASSET__Bm_RCBoZ__"